import CalendarViewWeekIcon from '@mui/icons-material/CalendarViewWeek';
import ClearIcon from '@mui/icons-material/Clear';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import InvertColorsIcon from '@mui/icons-material/InvertColors';
import ListIcon from '@mui/icons-material/List';
import {
  Box,
  Button,
  Chip,
  Divider,
  Grid,
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import { GREEN_COLOR } from '../../../constants/ColorsConst';
import * as CONST from '../../../constants/FieldsConst';
import { diasDeSemanaUtil } from '../../../helpers';
import { useNotification } from '../../../helpers/Notification';
import * as ROUTES from '../../../router/Routes';
import { DrawerWidget, LoadingWidget } from '../../../widgets';
import DeleteModalComponent from '../../../widgets/modals/DeleteModal';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { oneEntAjustesAction } from '../../entidad/ent_ajustes/EntAjustesAction';
import {
  allHorariosAction,
  deleteHorariosAction,
  saveHorariosAction,
  setActivoHorariosAction,
} from './HorariosAction';
import { PARAMS_HORARIOS, SETTINGS_HORARIOS } from './HorariosReducer';
import FiltrosHorariosComponent from './components/FiltrosHorarios';
import FormHorarios from './components/FormHorarios';
import ListadoHorarios from './components/ListadoHorarios';
import VistaHorariosComponent from './components/VistaHorarios';
import ExportExcelHorarios from './excel';

export function getDataHorario(isAdminTeacher, data) {
  return (
    <>
      <Typography>
        <strong>Horario:</strong> {data.dia}
        {'  '}
        {data.horaInicio}-{data.horaFinal}
      </Typography>
      <Typography>
        <strong>Materia:</strong> {data.materia.nombre}
      </Typography>
      <Typography>
        <strong>Nivel académico:</strong>{' '}
        {data.seccion.nivelAcademico.nivelAcademico.nombre}{' '}
        <strong>Sección:</strong> {data.seccion.nombre} <strong>Turno:</strong>{' '}
        {data.seccion.turno}{' '}
      </Typography>
      <Typography>
        <strong>Docente:</strong> {data.docente.usuario.perfil.pnombre}{' '}
        {data.docente.usuario.perfil.papellido}
      </Typography>
      {!isAdminTeacher && (
        <Stack direction="row" alignItems="center">
          <Typography sx={{ mr: 1 }}>
            <strong>Dias asignados:</strong>
          </Typography>
          {data.docente.diasClases.dias.map((el) => {
            return (
              <Chip key={`diaa-${el}`} label={el} size="small" sx={{ mr: 1 }} />
            );
          })}
        </Stack>
      )}
    </>
  );
}

const HorariosView = () => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const entHorariosClasesStore = Redux.useSelector(
    (state) => state.entHorariosClases,
  );
  const horariosStore = Redux.useSelector((state) => state.horarios);
  const templateStore = Redux.useSelector((state) => state.template);

  const [openForm, setOpenForm] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [isCalendar, setIsCalendar] = React.useState(true);
  const [loadingSave, setLoadingSave] = React.useState(false);
  const [isDuplicar, setIsDuplicar] = React.useState(false);

  const dataInit = {
    dia: null,
    horaInicio: '07:00',
    horaFinal: '07:45',
  };
  const [data, setData] = React.useState(dataInit);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  React.useEffect(() => {
    if (!entHorariosClasesStore.activo) {
      return history.push(ROUTES.horarios.to);
    }

    async function fetchData() {
      if (!entidadesStore.ajustes?.periodoAcademico) {
        await oneEntAjustesAction(dispatch, entidadesStore.ajustes.id);
      }
      const payload = {
        ...horariosStore.params,
        idEntidad: entidadesStore.activo.id,
        idHorarioClase: entHorariosClasesStore.activo.id,
        idPeriodoAcademico: entidadesStore.ajustes.periodoAcademico.id,
      };
      dispatch({ type: PARAMS_HORARIOS, payload });
      setActivoHorariosAction(dispatch, null);
      dispatch({
        type: SETTINGS_HORARIOS,
        payload: {
          ...horariosStore.settings.newHorario,
          newHorario: null,
        },
      });
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    setOpenForm(horariosStore.settings.newHorario ?? false);
  }, [horariosStore.settings.newHorario]);

  return (
    <Grid container spacing={1} sx={{ mb: '20%' }}>
      <Grid
        item
        xs={12}
        md={12}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Box>
          <BotonComponent
            click={async () => {
              await setActivoHorariosAction(dispatch, null);
              setOpenForm(true);
            }}
            green
            addIcon
            mr={2}
          />
          {(horariosStore.params.idDocente ||
            horariosStore.params.idSeccion ||
            horariosStore.params.idNivelAcademico) &&
            horariosStore.all.length > 0 && (
              <BotonComponent
                click={async () => {
                  await setActivoHorariosAction(dispatch, null);
                  await allHorariosAction(
                    { dispatch, horariosStore },
                    horariosStore.params,
                  );
                }}
                disabled={horariosStore.loadingAll}
                white
                mr={2}
                refreshIcon
                text={
                  horariosStore.loadingAll ? 'Actualizando...' : 'Actualizar'
                }
              />
            )}

          {!horariosStore.settings.isCut && (
            <BotonComponent
              click={async () => {
                setIsCalendar(!isCalendar);
              }}
              startIcon={!isCalendar ? <CalendarViewWeekIcon /> : <ListIcon />}
              orange
              text={isCalendar ? 'Modo lista' : 'Modo calendario'}
              mr={2}
            />
          )}
          {(horariosStore.params.idDocente || horariosStore.params.idSeccion) &&
            !loginStore.isAdminTeacher && <ExportExcelHorarios />}
        </Box>
        {horariosStore.all.length > 0 && (
          <Box>
            {horariosStore.settings.isCalendarioSeparados && (
              <Button
                size="small"
                color={
                  horariosStore.settings.isHorizontal ? 'success' : 'warning'
                }
                onClick={() =>
                  dispatch({
                    type: SETTINGS_HORARIOS,
                    payload: {
                      ...horariosStore.settings,
                      isHorizontal: !horariosStore.settings.isHorizontal,
                    },
                  })
                }
                variant="contained"
                sx={{
                  mr: 1,
                }}
              >
                {horariosStore.settings.isHorizontal
                  ? 'Vertical'
                  : 'Horizontal'}
              </Button>
            )}
            {isCalendar && (
              <Button
                size="small"
                onClick={() =>
                  dispatch({
                    type: SETTINGS_HORARIOS,
                    payload: {
                      ...horariosStore.settings,
                      isEditCalendar: !horariosStore.settings.isEditCalendar,
                      isEstatus: false,
                    },
                  })
                }
                variant={
                  horariosStore.settings.isEditCalendar
                    ? 'contained'
                    : 'outlined'
                }
                sx={{
                  mr: 1,
                }}
              >
                {!horariosStore.settings.isEditCalendar
                  ? 'Editar'
                  : 'Cerrar edición'}
              </Button>
            )}
            {horariosStore.settings.isColor ||
            !isCalendar ||
            horariosStore.settings.isEditCalendar ? null : (
              <Button
                size="small"
                color="success"
                onClick={() =>
                  dispatch({
                    type: SETTINGS_HORARIOS,
                    payload: {
                      ...horariosStore.settings,
                      isEstatus: !horariosStore.settings.isEstatus,
                    },
                  })
                }
                variant={
                  horariosStore.settings.isEstatus ? 'contained' : 'outlined'
                }
                sx={{
                  mr: 1,
                }}
              >
                {!horariosStore.settings.isEstatus
                  ? 'Estatus'
                  : 'Ocultar Estatus'}
              </Button>
            )}
            {isCalendar && (
              <>
                {!horariosStore.settings.isEditCalendar && (
                  <>
                    <Tooltip
                      describeChild
                      title="Recorte de imagén"
                      placement="bottom"
                    >
                      <IconButton
                        aria-label="delete"
                        onClick={() =>
                          dispatch({
                            type: SETTINGS_HORARIOS,
                            payload: {
                              ...horariosStore.settings,
                              isCut: !horariosStore.settings.isCut,
                            },
                          })
                        }
                        sx={{
                          backgroundColor: horariosStore.settings.isCut
                            ? GREEN_COLOR
                            : null,
                          color: horariosStore.settings.isCut ? 'white' : null,
                          '&:hover': {
                            color: 'black',
                          },
                          mr: 0.5,
                        }}
                      >
                        <ContentCutIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip
                      describeChild
                      title="Eliminar el color"
                      placement="bottom"
                    >
                      <IconButton
                        aria-label="delete"
                        sx={{
                          backgroundColor: horariosStore.settings.isColor
                            ? GREEN_COLOR
                            : null,
                          color: horariosStore.settings.isColor
                            ? 'white'
                            : null,
                          '&:hover': {
                            color: 'black',
                          },
                        }}
                        onClick={() =>
                          dispatch({
                            type: SETTINGS_HORARIOS,
                            payload: {
                              ...horariosStore.settings,
                              isColor: !horariosStore.settings.isColor,
                            },
                          })
                        }
                      >
                        <InvertColorsIcon />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
              </>
            )}
          </Box>
        )}
      </Grid>
      <Grid item xs={12} md={12}>
        <FiltrosHorariosComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        {isCalendar ? (
          <>
            <LoadingWidget isLoading={horariosStore.loadingAll} />
            <VistaHorariosComponent setOpenForm={(val) => setOpenForm(val)} />
          </>
        ) : (
          <ListadoHorarios setOpenForm={(val) => setOpenForm(val)} />
        )}
      </Grid>

      {horariosStore.activo && horariosStore.settings.isEditCalendar && (
        <Box
          sx={{
            position: 'fixed',
            bottom: '2%',
            zIndex: 100,
            left: templateStore.openDrwamer ? '21%' : '6%',
          }}
        >
          <Box
            sx={{
              boxShadow: '4px -3px 15px rgba(0,0,0,0.5)',
              backgroundColor: 'white',
              width: '600px',
              p: 1,
              borderRadius: '8px',
              position: 'relative',
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12} md={12}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>
                    {horariosStore.activo.id} - Horario
                  </Typography>
                  <Tooltip describeChild title="Cerrar" placement="top">
                    <IconButton
                      aria-label="cerrar"
                      color="error"
                      onClick={() => {
                        setActivoHorariosAction(dispatch, null);
                      }}
                    >
                      <ClearIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>
                {getDataHorario(
                  loginStore.isAdminTeacher,
                  horariosStore.activo,
                )}
              </Grid>

              {isDuplicar && (
                <>
                  <Grid item xs={12} md={12}>
                    <Divider textAlign="left" sx={{ my: 1 }}>
                      <strong>Duplicar horario</strong>
                    </Divider>
                    <LoadingWidget
                      isLoading={loadingSave}
                      text={'Duplicando horarios...'}
                    />
                    <Typography variant="body1" color="initial">
                      Seleccione un día
                    </Typography>
                    {diasDeSemanaUtil.map((dia, i) => (
                      <Button
                        key={i}
                        size="small"
                        variant={
                          data.dia === dia.dia ? 'contained' : 'outlined'
                        }
                        sx={{ mr: 1 }}
                        onClick={() =>
                          _handleSetDataField(CONST.dia.name, dia.dia)
                        }
                      >
                        {dia.abrev}
                      </Button>
                    ))}
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      size="small"
                      type="time"
                      label={CONST.horaInicio.label}
                      value={data.horaInicio}
                      onChange={(e) =>
                        _handleSetDataField(
                          CONST.horaInicio.name,
                          e.target.value,
                        )
                      }
                      id={CONST.horaInicio.name}
                      InputProps={{
                        inputProps: { min: 1 },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      size="small"
                      type="time"
                      label={CONST.horaFinal.label}
                      value={data.horaFinal}
                      onChange={(e) =>
                        _handleSetDataField(
                          CONST.horaFinal.name,
                          e.target.value,
                        )
                      }
                      id={CONST.horaFinal.name}
                      InputProps={{
                        inputProps: { min: 1 },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={12} align="center">
                    <BotonComponent
                      click={async () => {
                        if (!data.dia) {
                          notify('Falta seleccionar el día de clase', {
                            warning: true,
                          });
                        }
                        setLoadingSave(true);
                        const a = horariosStore.activo;
                        const res = await saveHorariosAction(
                          { dispatch, notify },
                          null,
                          {
                            dia: data.dia,
                            horaInicio: data.horaInicio,
                            horaFinal: data.horaFinal,
                            color: a.color,
                            grupo: a.grupo,
                            idEntidad: entidadesStore.activo.id,
                            idMateria: a.materia.id,
                            idSeccion: a.seccion.id,
                            idHorario: entHorariosClasesStore.activo.id,
                            idDocente: a.docente.id,
                            idAula: a.aula?.id,
                            idEstatus: 1,
                          },
                          horariosStore.params,
                        );

                        if (res) {
                          setIsDuplicar(false);
                          setData(dataInit);
                        }
                        setLoadingSave(false);
                      }}
                      text="GUARDAR"
                      disabled={loadingSave}
                      green
                      saveIcon
                      mr={2}
                    />
                    <Divider sx={{ my: 1 }} />
                  </Grid>
                </>
              )}
              <Grid item xs={12} md={12}>
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="flex-end"
                  justifyContent="flex-end"
                >
                  <Tooltip
                    describeChild
                    title={isDuplicar ? 'Cancelar' : 'Duplicar'}
                    placement="bottom"
                  >
                    <IconButton
                      aria-label={isDuplicar ? 'Cancelar' : 'Duplicar'}
                      color={isDuplicar ? 'error' : 'primary'}
                      onClick={() => {
                        setIsDuplicar(!isDuplicar);
                        setLoadingSave(false);
                        setData(dataInit);
                      }}
                    >
                      {isDuplicar ? <ClearIcon /> : <ContentCopyIcon />}
                    </IconButton>
                  </Tooltip>
                  <Tooltip describeChild title="Eliminar" placement="bottom">
                    <IconButton
                      aria-label="eliminar"
                      color="error"
                      onClick={() => {
                        setOpenModalDelete(true);
                      }}
                    >
                      <DeleteForeverIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
      <DrawerWidget open={openForm} onClose={(val) => setOpenForm(val)}>
        <FormHorarios
          setOpenForm={setOpenForm}
          setOpenModalDelete={setOpenModalDelete}
        />
      </DrawerWidget>
      {horariosStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={async () => {
            await deleteHorariosAction(
              { dispatch, notify },
              horariosStore.activo.id,
              horariosStore.params,
            );
            setOpenModalDelete(!openModalDelete);
            dispatch({
              type: SETTINGS_HORARIOS,
              payload: {
                ...horariosStore.settings,
                newHorario: null,
              },
            });
          }}
        >
          {getDataHorario(loginStore.isAdminTeacher, horariosStore.activo)}
        </DeleteModalComponent>
      )}

      {/* <HorarioAutoView /> */}
    </Grid>
  );
};

export default HorariosView;
